//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    title: String,
    isRed: {
      type: Boolean,
      default: false
    },
    id: String,
    catId: String,
    range: Array,
    linkName: String
  },
  computed: {
    prevSlug () {
      const index = this.range.findIndex(el => el.id === this.id)

      if (index <= 0) {
        return null
      } else {
        return this.range[index - 1].attributes.name
      }
    },
    nextSlug () {
      const index = this.range.findIndex(el => el.id === this.id)

      if (index < 0 || index === this.range.length - 1) {
        return null
      } else {
        return this.range[index + 1].attributes.name
      }
    },
    canIncrement () {
      return this.nextSlug
    },
    canDecrement () {
      return this.prevSlug
    }
  }
}

